import { Edge, EdgeMarker, Node } from "reactflow"
import { VehicleModulesResearchResponse } from "../../../models/response/VehicleModulesResearchResponse"
import { ModuleTypes } from "../../../models/VehicleModule"

export const buildModuleEdges : (data: VehicleModulesResearchResponse | null, nodes: Node<any, string | undefined>[]) => Edge<any>[] = (data: VehicleModulesResearchResponse | null, nodes: Node<any, string | undefined>[]) => {
	if (!data) return []
	const edges: Edge<any>[] = [
		getLeftNodeToPictureEdge(),
		...getPictureToPaneEdges(),
		...getEdgesBetweenModules(nodes),
		getPaneToRightNodeEdge()
	]

	return edges
}

const getPaneToRightNodeEdge = () => {
	return {
		id: "pane-to-right",
		source: "module-ENGINE-4",
		type: "smoothstep",
		target: "right-vehicle",
		animated: false,
		reconnectable: false,
		style: { stroke: "#fff", strokeWidth: 2},
		markerEnd: {
			type: 'arrowclosed',
			color: '#fff',
			width: 10,
			height: 10
		} as EdgeMarker
	}
}

const getEdgesBetweenModules = (nodes: Node<any, string | undefined>[]) => {
	const edges: Edge<any>[] = []
	const elements = {
		ENGINE: 5,
		BRAKES: 4,
		TRANSMISSION: 4,
		TURBO: 2,
		TYRES: 2
	}
	Object.entries(elements).forEach(([moduleType, amountOfModules]) => {

		for (let i = 1; i < amountOfModules; i++) {
			const parentNode = nodes.find((node) => node.id === `module-${moduleType}-${i - 1}`)
			const node = nodes.find((node) => node.id === `module-${moduleType}-${i}`)
			
			const parentIsResearchedOrBought = parentNode?.data.checked || parentNode?.data.isResearched
			const nodeIsResearchedAndBought = node?.data.checked && node?.data.isResearched
			const getMarkerEnd = () => {
				if (nodeIsResearchedAndBought || parentIsResearchedOrBought) {
					return {
						type: 'arrowclosed',
						color: '#fff',
						width: 10,
						height: 10
					} as EdgeMarker
				} else {
					return {
						type: 'arrowclosed',
						color: '#444',
						width: 10,
						height: 10
					} as EdgeMarker
				}
			}

			const getStyle = () => {
				if (nodeIsResearchedAndBought) {
					return { stroke: "#fff", strokeWidth: 2}
				}
				if (parentIsResearchedOrBought) {
					return { stroke: "#fff", strokeWidth: 2, strokeDasharray: "5 5"}
				} else {
					return { stroke: "#444", strokeWidth: 2, strokeDasharray: "5 5"}
				}
			}

			edges.push(
				{
					id: `module-${moduleType}-${i}-to-module-${moduleType}-${i - 1}`,
					source: `module-${moduleType}-${i - 1}`,
					type: "smoothstep",
					target: `module-${moduleType}-${i}`,
					animated: false,
					reconnectable: false,
					style: getStyle(),
					markerEnd: getMarkerEnd()
				}
			)
		}
		
	})

	return edges
}

const getPictureToPaneEdges = () => {
	const types = Object.values(ModuleTypes)
	return types.map((type) => {
		return {
			id: `picture-to-${type}`,
			source: "vehicle-picture",
			type: type === 'TRANSMISSION' ? "straight" : "smoothstep",
			target: "module-" + type + "-0",
			animated: false,
			reconnectable: false,
			style: { stroke: "#fff", strokeWidth: 2},
			markerEnd: {
				type: 'arrowclosed',
				color: '#fff',
				width: 10,
				height: 10
			} as EdgeMarker
		}
	})
}

const getLeftNodeToPictureEdge = () => {
	return {
		id: "left-to-picture",
		source: "left-vehicle",
		type: "straight",
		target: "vehicle-picture",
		animated: false,
		reconnectable: false,
		style: { stroke: "#fff", strokeWidth: 2},
		markerEnd: {
			type: 'arrowclosed',
			color: '#fff',
			width: 10,
			height: 10
		} as EdgeMarker
	}
}